// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-row[data-v-85cd6aec] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-bottom: 10px;\n  padding-left: 10px;\n}\n.label[data-v-85cd6aec] {\n  font-size: 14px;\n  color: #606266;\n  font-weight: 700;\n}\n", ""]);
// Exports
module.exports = exports;
